import React from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { getVideogamesbyName } from "../../actions";
import "../SearchBar/SearchBar.css"
export default function SearchBar({setcurrentPage}){
    const dispatch=useDispatch();

    const [name, setName] = useState("");

    function handleInputChange(event){
        event.preventDefault();
        setName(event.target.value);
    }

    function handleSubmit(event){
        event.preventDefault();
        dispatch(getVideogamesbyName(name))
        setcurrentPage(1)
        setName('')
    }
    return(
        <div className="containerSearch">
            <input className="inputSearch"
            value={name}
            type="text" 
            placeholder="Buscar..." 
            onChange={(event) => handleInputChange(event)}
            />
            <button className="buttonSearch"
            type="submit" 
            onClick={(event) => handleSubmit(event)}
            >
            GO!
            </button>
        </div>
    )
}